import React from 'react';
import { Link } from 'react-router-dom';

import elite_logo from '../../assets/images/elite-logo.png';
import logo_white from '../../assets/images/logo_white.svg';
import Container from '../container/Container';

export const Footer: React.FC = () => {
  return (
    <footer className="footer bg-purple-700 pt-24 pb-4">
      <Container>
        <div className="grid grid-cols-4 gap-4">
          <div className="footer-brand">
            <img src={logo_white} alt="" />
            <img className="w-32 mt-10" src={elite_logo} alt="" />
          </div>
          <div className="footer-nav">
            <div className="footer-heading uppercase">Vero Learning</div>
            <ul>
              <li>
                <Link to="/">About</Link>
              </li>
              <li>
                <Link to="/signup">Sign Up</Link>
              </li>
              <li>
                <Link to="/">Student and Employees Feedback</Link>
              </li>
              <li>
                <Link to="/">Hiring Manager Feedback</Link>
              </li>
              <li>
                <Link to="/">Free Resources</Link>
              </li>
            </ul>
          </div>
          <div className="footer-nav">
            <div className="footer-heading uppercase">Legal</div>
            <ul>
              <li>
                <Link to="/">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/">Terms and Condations</Link>
              </li>
            </ul>
          </div>
          <div className="footer-nav">
            <div className="footer-heading uppercase">subscribe</div>
            <div className="get-updates">
              <input
                className="bg-white p-5 border w-full shadow rounded-xl"
                type="text"
                placeholder="Get Updates"
              />
            </div>
          </div>
        </div>
        <div className="sub-footer mt-12">
          <p className="text-white text-center pt-4">
            &copy; 2023 Vero Learning LLC. All rights reserved.
          </p>
          <p className="text-white text-center pt-4">
            <small>
              {process.env.REACT_APP_VERSION ? `v${process.env.REACT_APP_VERSION}` : ''}:
              {process.env.REACT_APP_GIT_SHA
                ? `${process.env.REACT_APP_GIT_SHA.substring(0, 7)}`
                : ''}
            </small>
          </p>
        </div>
      </Container>
    </footer>
  );
};
